const addZeroIfNeeded = (number) =>
    number < 10 ? "0" + number : String(number);

export const getDefaultInputDate = () => {
    const today = new Date();

    return `${today.getFullYear()}-${addZeroIfNeeded(
        today.getMonth() + 1,
    )}-${addZeroIfNeeded(today.getDate())}`;
};
